<template>
  <div>
    <v-container fluid fill-height class="pa-0">
      <v-hover v-slot:default="{ hover }">
        <v-carousel
          :cycle="hover ? false : true"
          hide-delimiters
          :show-arrows="false"
          height="calc(95vh - 165px)"
          class="max-h70vh">
          <v-carousel-item
            v-for="(slide, i) in headerlist"
            :key="i"
            :lazy-src="require('../assets/default.jpg')"
            :src="slide.urlpic"
            class="max-h70vh">
            <v-container
              fill-height
              fluid
              pa-0 ma-0
              class="max-h70vh">
              <v-container class="pa-0">
                <v-layout
                  fill-height>
                  <v-flex
                    xs12
                    :align-self-end="!$vuetify.breakpoint.smAndDown"
                    :align-self-center="$vuetify.breakpoint.smAndDown">
                    <v-card
                      tile
                      color="transparent"
                      flat>
                      <v-card-text class="background-trans-style">
                        <div>
                          <h1 class="white--text text-md-h2 mb-5 title-page">{{ $t('title.intcourse') }}</h1>
                          <h2 class="white--text text-md-h4 mb-5">
                            {{ $t('header.tagline') }}
                          </h2>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-container>
          </v-carousel-item>
        </v-carousel>
      </v-hover>
    </v-container>
    <v-container class="my-10">
      <v-row>
        <v-col cols="12" md="12">
          <v-row justify="center" class="black--text">
            <v-col cols="12" md="12">
              <h2 class="text-md-h4 font-weight-bold sub-title-page">
                {{ $t('title.intcourse') }}
              </h2>
            </v-col>
            <v-col cols="12" md="12" class="text-md-justify">
              <div v-if="$i18n.locale === 'en'">
                Politeknik Negeri Bali located in one of the seventeen thousand islands of Indonesia, called Bali. The Island has been internationally exposed since 1920s, known for its rich culture, natural beauty and the hospitality of its people. Bali has been baptized as the main tourist destination in Indonesia, you will not consider have visited Indonesia before visiting Bali. Our campus community grows and develops within the context of our traditional culture and our international exposure. The campus is situated amid the triangle of Bali’s main tourist resorts, Kuta, Nusa Dua and Jimbaran, the tourism ecosystem has made Politeknik Negeri Bali nominated by the ministry of higher education research and technology as the center of technology in green tourism. All departments integrate sustainability in their program.
              </div>
              <div v-if="$i18n.locale === 'id'">
                Politeknik Negeri Bali terletak di salah satu dari tujuh belas ribu pulau di Indonesia yang disebut Bali. Pulau ini telah diekspos secara internasional sejak tahun 1920-an, dikenal karena budayanya yang kaya, keindahan alam, dan keramahan penduduknya. Bali telah dibaptis sebagai tujuan wisata utama di Indonesia, Anda tidak akan dianggap telah mengunjungi Indonesia sebelum mengunjungi Bali. Komunitas kampus kami tumbuh dan berkembang dalam konteks budaya tradisional kami dan eksposur internasional kami. Kampus yang terletak di tengah segitiga resor wisata utama Bali, Kuta, Nusa Dua dan Jimbaran, ekosistem pariwisata telah membuat Politeknik Negeri Bali dinominasikan oleh kementerian penelitian dan teknologi pendidikan tinggi sebagai pusat teknologi dalam pariwisata hijau. Semua departemen mengintegrasikan keberlanjutan dalam program mereka.
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <v-img
                :src="require('../assets/int-class.jpeg')">
              </v-img>
            </v-col>
            <v-col cols="12" md="6" class="text-md-justify">
              <div v-if="$i18n.locale === 'en'">
                <p>
                  Politeknik Negeri Bali, has developed partnership with universities overseas to invite foreign students to study and enjoy our academic uniqueness blended with our traditional culture. We are offering the following programs for our inbound mobility.
                </p>
                <ul class="mb-3">
                  <li>Double degree programs</li>
                  <li>Student exchange</li>
                  <li>Extension Program</li>
                  <li>Collaborative International offline Learning</li>
                  <li>Collaborative International online learning</li>
                  <li>Summer Course</li>
                  <li>Joint Research</li>
                  <li>Joint community services</li>
                  <li>Guest lecturer (off/on line)</li>
                </ul>
                <p>
                  look forward to welcoming you both offline or online.
                </p>
              </div>
              <div v-if="$i18n.locale === 'id'">
                <p>
                  Politeknik Negeri Bali, telah mengembangkan kemitraan dengan universitas di luar negeri untuk mengundang mahasiswa asing untuk belajar dan menikmati keunikan akademik kami yang berpadu dengan budaya tradisional kami. Kami menawarkan program berikut untuk mobilitas masuk kami.
                </p>
                <ul class="mb-3">
                  <li>Double degree programs</li>
                  <li>Student exchange</li>
                  <li>Extension Program</li>
                  <li>Collaborative International offline Learning</li>
                  <li>Collaborative International online learning</li>
                  <li>Summer Course</li>
                  <li>Joint Research</li>
                  <li>Joint community services</li>
                  <li>Guest lecturer (off/on line)</li>
                </ul>
                <p>
                  berharap dapat menyambut Anda baik offline atau online.
                </p>
              </div>
              <v-btn
                :color="maincolor"
                class="white--text"
                :to="{ name: 'NewsDetail', query: { berita: 25 } }">
                {{ $t('button.enroll') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid fill-height class="py-10 min-height-pages bacground-maincolor">
      <v-container class="px-0 px-md-3">
        <v-row>
          <v-col cols="12" md="4">
            <v-card
              tile
              flat
              :to="{ name: 'Coursereg' }">
              <v-card-title class="font-weight-bold">
                <div>
                  {{ $t('title.regcourse') }}
                </div>
                <v-spacer></v-spacer>
                <v-icon
                  :color="maincolor">
                  mdi-open-in-new
                </v-icon>
              </v-card-title>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card
              tile
              flat
              :to="{ name: 'Courseint' }">
              <v-card-title class="font-weight-bold">
                <div>
                  {{ $t('title.intcourse') }}
                </div>
                <v-spacer></v-spacer>
                <v-icon
                  :color="maincolor">
                  mdi-open-in-new
                </v-icon>
              </v-card-title>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card
              tile
              flat
              :to="{ name: 'Coursecoop' }">
              <v-card-title class="font-weight-bold">
                <div>
                  {{ $t('title.coopcourse') }}
                </div>
                <v-spacer></v-spacer>
                <v-icon
                  :color="maincolor">
                  mdi-open-in-new
                </v-icon>
              </v-card-title>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card
              tile
              flat
              :to="{ name: 'Courserpl' }">
              <v-card-title class="font-weight-bold">
                <div>
                  {{ $t('title.rplcourse') }}
                </div>
                <v-spacer></v-spacer>
                <v-icon
                  :color="maincolor">
                  mdi-open-in-new
                </v-icon>
              </v-card-title>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card
              tile
              flat
              :to="{ name: 'Coursespe' }">
              <v-card-title class="font-weight-bold">
                <div>
                  {{ $t('title.specialcourse') }}
                </div>
                <v-spacer></v-spacer>
                <v-icon
                  :color="maincolor">
                  mdi-open-in-new
                </v-icon>
              </v-card-title>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <v-container class="my-10">
      <v-row>
        <v-col cols="12" md="12">
          <h2 class="text-md-h4 font-weight-bold sub-title-page">
            {{ $t('title.newsedu') }}
          </h2>
        </v-col>
      </v-row>
      <v-row v-if="newslist.length">
        <v-col
          class="d-flex"
          cols="12"
          md="4"
          v-for="(news, i) in newslist"
          :key="i">
          <v-card
            class="d-flex flex-column w100">
            <v-img
              class="white--text align-end flex-grow-0 flex-shrink-1"
              height="225px"
              :src="news.urlpic">
            </v-img>
            <v-card-subtitle>
              <h1 class="title font-weight-bold mb-3">
                <router-link class="text-decoration-none text-ellipsis--2"
                  :title="news.judul_berita"
                  :to="{ name: 'NewsDetail', query: { berita: news.id_berita } }">
                  {{ news.judul_berita }}
                </router-link>
              </h1>
              <div class="d-flex">
                <v-chip
                  class="mr-1"
                  color="deep-orange"
                  small
                  dark
                  :title="news.tgl_berita">
                  <v-icon left small>
                    mdi-update
                  </v-icon>
                  <timeago :datetime="news.tgl_berita"></timeago>
                </v-chip>
                <v-chip
                  class="mr-1"
                  color="primary"
                  small
                  dark>
                  <v-icon left small>
                    mdi-alpha-c-circle
                  </v-icon>
                  {{ news.cat_berita }}
                </v-chip>
                <v-spacer></v-spacer>
                <ShareNetwork
                  network="facebook"
                  :url="getRouteUrl('NewsDetail', { berita: news.id_berita })"
                  :title="news.judul_berita"
                  :description="news.prev_berita"
                  :quote="news.prev_berita"
                  hashtags="international,pnb,bali"
                  class="text-decoration-none d-inline mr-1">
                  <v-icon color="indigo">
                    mdi-facebook
                  </v-icon>
                </ShareNetwork>
                <ShareNetwork
                  network="whatsapp"
                  :url="getRouteUrl('NewsDetail', { berita: news.id_berita })"
                  :title="news.judul_berita"
                  :description="news.prev_berita"
                  :quote="news.prev_berita"
                  hashtags="international,pnb,bali"
                  class="text-decoration-none d-inline mr-1">
                  <v-icon color="green">
                    mdi-whatsapp
                  </v-icon>
                </ShareNetwork>
              </div>
            </v-card-subtitle>
            <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
              <div v-html="news.prev_berita"></div>
            </v-card-text>
            <v-card-actions v-if="false">
              <v-btn
                class="mx-2"
                fab
                depressed
                dark
                x-small
                :to="{ name: 'NewsDetail', query: { berita: news.id_berita } }">
                <v-icon dark>
                  mdi-arrow-right
                </v-icon>
              </v-btn>
              <span>{{ $t('button.readmore') }}</span>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="12">
          <v-btn
            large
            :color="maincolor"
            dark
            :to="{ name: 'News', query: { type: 'berita', category: 'pendidikan' } }"
            exact>
            {{ $t('button.othernews') }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="!newslist.length">
        <v-col cols="12" md="12">
          <div class="grey--text my-2">
            Berita pada kategori ini tidak ditemukan.
          </div>
        </v-col>
        <v-col cols="12" md="12">
          <v-btn
            large
            :color="maincolor"
            dark
            :to="{ name: 'News', query: { type: 'berita', category: 'pendidikan' } }"
            exact>
            {{ $t('button.othernews') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Courseint',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
    },
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    filter: {
      search: '',
    },
    headers: [
      { text: 'Nama', value: 'nama_kerja' },
      { text: 'Deskripsi', value: 'deskripsi_kerja' },
      { text: 'Status', value: 'status_kerja' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    newslist: [],
    addjeniskerja: {
      nama_kerja: '',
      deskripsi_kerja: '',
      email: '',
      company: '',
    },
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    paramberita: {
      search: '',
      limit: '',
      offset: '',
      lang: '',
      type: '',
      category: '',
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (!!v && v.length >= 8) || 'Min 8 characters',
      nik: (v) => (!!v && v.length >= 16) || 'Min 16 characters',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      },
    },
    tabdata: null,
    dmodal: {
      jeniskerja: false,
    },
    dmodaldata: {
      jeniskerja: null,
    },
    headerlist: [
      {
        id_berita: '',
        judul_berita: '',
        urlpic: require('./../assets/int-class.jpeg'),
      },
    ],
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    this.getBerita();
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  watch: {
    '$i18n.locale'(val) {
      if (val) {
        // console.log(val);
        this.updateLanguage();
      }
    },
  },
  methods: {
    getRouteUrl(nameroute, paramroute) {
      const props = this.$router.resolve({
        name: nameroute,
        query: paramroute,
      });
      // console.log(props);
      return this.baseurl + '' + props.href;
    },
    updateLanguage() {
      this.getBerita();
    },
    getBerita() {
      this.newslist = [];
      this.paramberita.lang = this.$i18n.locale;
      this.paramberita.limit = 6;
      this.paramberita.type = 'berita';
      this.paramberita.category = 'pendidikan';
      this.axios
        .get(
          this.api + '/public/berita',
          {
            params: this.paramberita,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              resdata.data.forEach((element) => {
                if (element.pic_berita) {
                  element.urlpic = this.api + '/upload/news/' + element.pic_berita;
                } else {
                  element.urlpic = require('../assets/default.jpg');
                }
                this.newslist.push(element);
              });
              // console.log(this.newslist);
            }
          }
          // this.loading.check = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loading.check = false;
        });
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
